export default "__VITE_ASSET__Bps3IPbw__"